/**
 * Returns true if `value` represents a number in base 10.
 */
export const isNumber = (value: unknown): boolean => {
  return !isNaN(Number(value));
};
